module.exports = __webpack_public_path__ + "img/lg_ring_g_c_1_null@2x.f1f40dcc.png";